import { cn } from '@/utils/tailwind.util';

/** 메타·툴바의 세로 구분선. `border-neutral`(gray-300) 이어야 회색 배경 위에서 보인다. */
export const QuizBankDivider = ({
  className
}: {
  className?: string;
}) => <span aria-hidden className={cn('h-[12px] w-0 shrink-0 border-l border-neutral', className)} data-sentry-component="QuizBankDivider" data-sentry-source-file="QuizBankDivider.tsx" />;